import useGetProjectEstimates from './useGetProjectEstimates';

const useGetProjectEstimate = (
  projectId: string | undefined,
  estimateId: string | undefined
) => {
  const result = useGetProjectEstimates(projectId);
  const estimate = estimateId
    ? result.project?.estimates.find((e) => e.id === estimateId)
    : undefined;
  return {
    ...result,
    estimate,
  };
};

export default useGetProjectEstimate;
